import React from 'react';
import { Suggestion } from '@components/common/Suggestion';
import { useWebViewBridge } from '@fourthwall/webview-bridge';
import { useShopStage } from '@hooks';
import { routing } from '@utils/routing';
import { usePromotionsQuery } from '../../../../../pages/Promotions/pages/PromotionCodes';
import { Award } from '../../../components/Award/Award';
import { useCampaignStatus } from '../../../hooks/useCampaignStatus';
import { useRecommendationsDismiss } from '../../../hooks/useRecommendationsDismiss';
import setUpPromotions from '../assets/set-up-promotions.png';
const ID = 'promotions';
export const usePromotionsRecommendation = () => {
    const { recommendationsDismiss, createOnDismiss } = useRecommendationsDismiss();
    const { shopStage, isLoading: isLoadingShopStage } = useShopStage();
    const { promotionsQuery } = usePromotionsQuery(undefined, { staleTime: 60_000 });
    const { methods, isWebView } = useWebViewBridge();
    const { activeIncentives } = useCampaignStatus();
    const incentive = activeIncentives.find((i) => i.recommendationId === ID);
    return {
        promotionsRecommendation: {
            id: ID,
            enabled: shopStage.stage2 &&
                promotionsQuery.isSuccess &&
                promotionsQuery.data.page.elementsTotal === 0 &&
                recommendationsDismiss.promotions.visible,
            isLoading: isLoadingShopStage || promotionsQuery.isInitialLoading,
            suggestion: isWebView ? (React.createElement(Suggestion, { title: "Set up promotions", description: "Create promo codes, giveaway links, or auto-applied offers.", buttonLabel: "Set up promo codes", imageUrl: setUpPromotions, analytics: "setUpPromotions", onButtonClick: async () => {
                    await methods.openMobilePage?.({
                        mobile_path: 'promotion_list',
                        url: routing.promotions.self,
                    });
                } })) : (React.createElement(Suggestion, { title: "Set up promotions", description: "Create promo codes, giveaway links, or auto-applied offers.", buttonLabel: "Set up promo codes", buttonTo: routing.promotions.self, imageUrl: setUpPromotions, analytics: "setUpPromotions", onDismiss: createOnDismiss(recommendationsDismiss.promotions.dismiss), award: incentive ? (React.createElement(Award, { value: incentive.incentive.bonus.value, currency: "USD", text: "sample credit" })) : undefined })),
        },
    };
};
